export const WEEKDAYS_ARRAY = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday'
];

export const MONTHS_ARRAY = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
]

 export const WEEKDAYS = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
]

export const VEHICLE_INSPECTION_ITEMS = [
    'Brake Fluid',
    'Fuel Level',
    'Engine Oil Level',
    'Coolant Level',
    'Lights',
    'Steering',
    'Brakes',
    'Tyres',
    'Horn',
    'Mirrors',
    'Seatbelts',
    'Windscreen Wipers',
    'Windscreen Washers',
];

export const ORDERS_STATUS = {
    PENDING: 'PENDING',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED'
}

export const HOLIDAY_STATUS = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED'
}

export const ADMINUSER = "ADMINUSER";
